// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard redesign + app shell.
   Scoped under .rf-app / .rf-dash so it can coexist with App.css and style.css
   while the old dashboard is still routed. */

.rf-app *,
.rf-app *::before,
.rf-app *::after {
  box-sizing: border-box;
  /* App.css sets \`* { transition: 300ms }\`; this design has none. */
  transition: none;
}
.rf-app {
  --rf-ink: #191714;
  --rf-ink-hover: #332e26;
  --rf-canvas: #f6f4ef;
  --rf-card: #ffffff;
  --rf-card-soft: #fdfcfa;
  --rf-line: #e7e3da;
  --rf-line-soft: #f0ece3;
  --rf-muted: #8b8477;
  --rf-muted-2: #a29b8d;
  --rf-muted-3: #bdb6a7;
  --rf-body: #4a453c;
  --rf-body-2: #6f6a60;
  --rf-gold: var(--rf-brand);
  --rf-gold-hover: var(--rf-brand-hover);
  --rf-gold-lite: var(--rf-brand-lite);
  --rf-gold-bright: var(--rf-brand-bright);
  --rf-gold-tint: var(--rf-brand-tint);
  --rf-gold-tint-2: var(--rf-brand-line);
  --rf-teal: var(--rf-accent);
  --rf-up: #4d7a52;
  --rf-up-bg: #eaf1e9;
  --rf-warn: #b0872f;
  --rf-warn-bg: #f9f1de;
  --rf-down: #a8483e;
  --rf-down-bg: #f7ebe9;
  --rf-track: #eae6dd;
  --rf-dark-line: #302b23;
  --rf-dark-rule: #3a352c;
  --rf-dark-body: #b8b1a3;

  display: flex;
  /* the whole app sits in a rounded card with a 5px gutter around it */
  width: calc(100% - 10px);
  margin: 5px;
  min-height: calc(100vh - 10px);
  border: 1px solid var(--rf-line);
  border-radius: 14px;
  overflow: hidden;
  background: var(--rf-canvas);
  color: var(--rf-ink);
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}
.rf-app *,
.rf-app *::before,
.rf-app *::after {
  box-sizing: border-box;
}
.rf-serif {
  font-family: "Instrument Serif", Georgia, serif;
  font-weight: 400;
}
.rf-num {
  font-variant-numeric: tabular-nums;
}
.rf-nowrap {
  white-space: nowrap;
}
.rf-spacer {
  flex-grow: 1;
}
.rf-app a {
  color: var(--rf-gold);
  text-decoration: none;
}
.rf-app a:hover {
  color: var(--rf-gold-lite);
}

/* ---------------- sidebar ---------------- */
.rf-sidebar {
  position: relative;
  width: 236px;
  flex-shrink: 0;
  /* the slide (AppShell) passes through widths neither layout was built
     for — clip rather than wrap */
  overflow: hidden;
  background: var(--rf-card);
  border-right: 1px solid var(--rf-line);
  display: flex;
  flex-direction: column;
}
.rf-nav {
  padding: 14px 10px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex-grow: 1;
  overflow-y: auto;
}
.rf-nav-eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--rf-muted-2);
  padding: 8px 10px 6px;
}
.rf-nav-eyebrow.is-second {
  padding-top: 18px;
}
.rf-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  padding: 0 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font: 500 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-body);
  text-align: left;
  width: 100%;
}
.rf-nav-item.is-secondary {
  height: 34px;
}
.rf-nav-item:hover {
  background: var(--rf-canvas);
}
.rf-nav-item.is-active {
  background: #f2ede2;
  color: var(--rf-ink);
  font-weight: 600;
}
.rf-nav-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d8d2c5;
  flex-shrink: 0;
}
.rf-nav-item.is-active .rf-nav-dot {
  background: var(--rf-gold-lite);
}
.rf-nav-label {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}
.rf-nav-icon {
  font-size: 16px;
  color: var(--rf-body);
  flex-shrink: 0;
}
.rf-nav-item.is-active .rf-nav-icon {
  color: var(--rf-gold);
}
.rf-nav-count {
  font-size: 11px;
  font-weight: 600;
  color: var(--rf-brand-deep);
  background: var(--rf-line-soft);
  padding: 2px 7px;
  border-radius: 20px;
  font-variant-numeric: tabular-nums;
}
.rf-nav-item.is-active .rf-nav-count {
  background: var(--rf-gold-tint-2);
}
.rf-sidebar-user {
  border-top: 1px solid var(--rf-line);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rf-sidebar-user img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.rf-user-text {
  flex-grow: 1;
  min-width: 0;
}
.rf-user-name {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-user-role {
  font-size: 11px;
  color: var(--rf-muted);
}
.rf-user-switch {
  font: 600 11px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-gold);
  cursor: pointer;
  padding: 4px 8px;
  border: 1px solid var(--rf-line);
  border-radius: 6px;
  background: transparent;
}
.rf-user-switch:hover {
  background: var(--rf-gold-tint);
}

/* ---------------- main + top bar ---------------- */
.rf-main {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
/* bare chrome mode: wrappers vanish from layout, children keep their
   legacy layout context (and no rf-app fonts/vars leak onto them) */
.rf-bare {
  display: contents;
}
.rf-content {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.rf-topbar {
  height: 64px;
  flex-shrink: 0;
  background: var(--rf-card);
  border-bottom: 1px solid var(--rf-line);
  display: flex;
  align-items: center;
  padding: 0 28px;
  gap: 20px;
  /* App.css styles bare <header> globally (margin/bold/centered) — reset it */
  margin: 0;
  font-weight: normal;
  text-align: left;
}
.rf-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--rf-line);
  border-radius: 8px;
  background: var(--rf-card-soft);
  min-width: 260px;
  cursor: text;
}
.rf-search-icon {
  width: 13px;
  height: 13px;
  border: 1.5px solid var(--rf-muted-2);
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
}
.rf-search input {
  border: none;
  background: none;
  outline: none;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-ink);
  width: 100%;
}
.rf-search input::placeholder {
  color: var(--rf-muted-2);
}
.rf-clock {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  color: var(--rf-body);
  border-left: 1px solid var(--rf-line);
  height: 34px;
  padding-left: 16px;
}
.rf-clock b {
  font-weight: 600;
  color: var(--rf-ink);
}
.rf-clock span {
  color: var(--rf-muted-2);
}

/* ---------------- shared controls ---------------- */
.rf-segmented {
  display: flex;
  gap: 2px;
  background: var(--rf-track);
  padding: 3px;
  border-radius: 9px;
}
.rf-segmented button {
  border: none;
  cursor: pointer;
  padding: 6px 13px;
  border-radius: 7px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  background: transparent;
  color: #7c766a;
  white-space: nowrap;
}
.rf-segmented button.is-active {
  background: #fff;
  color: var(--rf-ink);
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);
}
.rf-btn {
  cursor: pointer;
  height: 34px;
  border-radius: 8px;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  white-space: nowrap;
}
.rf-btn-ghost {
  padding: 0 14px;
  border: 1px solid var(--rf-line);
  background: #fff;
  color: var(--rf-body);
}
.rf-btn-ghost:hover {
  background: var(--rf-canvas);
}
.rf-btn-primary {
  padding: 0 16px;
  border: none;
  background: var(--rf-gold);
  color: #fff;
}
.rf-btn-primary:hover {
  background: var(--rf-gold-hover);
}

.rf-card {
  background: var(--rf-card);
  border: 1px solid var(--rf-line);
  border-radius: 12px;
  padding: 18px 20px;
}
.rf-card-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 14px;
}
.rf-card-title {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
}
.rf-card-meta {
  font-size: 12px;
  color: var(--rf-muted);
  white-space: nowrap;
  padding-left: 12px;
}

/* ---------------- dashboard ---------------- */
.rf-dash {
  flex-grow: 1;
  padding: 22px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 0;
}
.rf-dash-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rf-dash-datemeta {
  font-size: 13px;
  color: var(--rf-body-2);
  white-space: nowrap;
}
.rf-dash-datemeta b {
  color: var(--rf-ink);
  font-weight: 600;
}

.rf-kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.rf-kpi {
  background: var(--rf-card);
  border: 1px solid var(--rf-line);
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rf-kpi-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rf-kpi-label {
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-muted);
  white-space: nowrap;
}
.rf-kpi-chip {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 20px;
  white-space: nowrap;
}
.rf-kpi-chip.tone-up {
  color: var(--rf-up);
  background: var(--rf-up-bg);
}
.rf-kpi-chip.tone-warn {
  color: var(--rf-warn);
  background: var(--rf-warn-bg);
}
.rf-kpi-chip.tone-down {
  color: var(--rf-down);
  background: var(--rf-down-bg);
}
.rf-kpi-value {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.rf-kpi-value .rf-figure {
  font-size: 40px;
  line-height: 0.95;
}
.rf-kpi-unit {
  font-size: 12.5px;
  color: var(--rf-muted);
  padding-bottom: 5px;
}
.rf-kpi-sub {
  font-size: 12px;
  color: var(--rf-body-2);
}

.rf-dash-grid {
  display: grid;
  grid-template-columns: 1.35fr 1fr;
  gap: 16px;
  flex-grow: 1;
  min-height: 0;
}
.rf-dash-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

/* pipeline */
.rf-pipeline {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rf-pipeline-row {
  display: flex;
  align-items: center;
  gap: 14px;
}
.rf-pipeline-label {
  width: 132px;
  flex-shrink: 0;
}
.rf-pipeline-task {
  font-size: 13px;
  font-weight: 600;
}
.rf-pipeline-sub {
  font-size: 11.5px;
  color: var(--rf-muted);
}
.rf-track {
  flex-grow: 1;
  height: 10px;
  background: var(--rf-line-soft);
  border-radius: 20px;
  overflow: hidden;
}
.rf-track > span {
  display: block;
  height: 100%;
  border-radius: 20px;
}
.rf-pipeline-count {
  width: 76px;
  text-align: right;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}
.rf-pipeline-count b {
  font-weight: 600;
}
.rf-pipeline-count span {
  color: var(--rf-muted-2);
}
.rf-pipeline-pct {
  width: 42px;
  text-align: right;
  font-size: 12.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

/* chart */
.rf-chart-card {
  display: flex;
  flex-direction: column;
}
.rf-chart-head {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin-bottom: 4px;
}
.rf-legend-group {
  display: flex;
  align-items: center;
  gap: 14px;
}
.rf-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--rf-body-2);
  white-space: nowrap;
}
.rf-legend i {
  width: 14px;
  height: 2px;
  display: block;
}
.rf-chart-lede {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
}
.rf-chart-lede .rf-figure {
  font-size: 30px;
  line-height: 1;
}
.rf-chart-lede span {
  font-size: 12.5px;
  color: var(--rf-muted);
}
.rf-chart {
  /* fixed height: the design's 210 chart units reduced by 30% */
  height: 147px;
  position: relative;
}

/* recent activity */
.rf-activity {
  display: flex;
  flex-direction: column;
}
.rf-activity-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 0;
  border-top: 1px solid var(--rf-line-soft);
}
.rf-activity-row:first-child {
  border-top: none;
  padding-top: 0;
}
.rf-activity-row:last-child {
  padding-bottom: 0;
}
.rf-activity-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.rf-activity-text {
  flex-grow: 1;
  min-width: 0;
}
.rf-activity-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--rf-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-activity-detail {
  font-size: 11.5px;
  color: var(--rf-muted);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-activity-amount {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--rf-ink);
  white-space: nowrap;
}
.rf-activity-time {
  font-size: 11.5px;
  color: var(--rf-muted-2);
  white-space: nowrap;
  min-width: 38px;
  text-align: right;
  flex-shrink: 0;
}

/* revenue (owner only) */
.rf-revenue {
  background: var(--rf-ink);
  border-radius: 12px;
  padding: 18px 20px;
  color: #fff;
}
.rf-revenue .rf-card-title {
  color: #fff;
}
.rf-revenue-owner {
  font-size: 11.5px;
  color: var(--rf-muted-2);
}
.rf-revenue-figures {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}
.rf-revenue-label {
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-muted-2);
  margin-bottom: 4px;
}
.rf-revenue-figure {
  font-size: 34px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.rf-revenue-figure.is-gross {
  color: var(--rf-gold-bright);
}
.rf-revenue-figure.is-net {
  color: #fff;
}
.rf-revenue-rule {
  width: 1px;
  background: var(--rf-dark-rule);
}
.rf-revenue-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-top: 1px solid var(--rf-dark-line);
  font-size: 12.5px;
}
.rf-revenue-row dt {
  margin: 0;
  color: var(--rf-dark-body);
}
.rf-revenue-row dd {
  margin: 0;
  color: #fff;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

/* top sellers */
.rf-sellers-card {
  /* hug the donut — no stretch, ~10px of air below */
  flex-grow: 0;
  padding-bottom: 10px;
}
.rf-sellers {
  display: flex;
  align-items: center;
  gap: 18px;
}
.rf-donut {
  width: 200px;
  height: 200px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rf-donut-hole {
  width: 127px;
  height: 127px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.rf-donut-total {
  font-size: 26px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.rf-donut-caption {
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--rf-muted-2);
  margin-top: 3px;
}
.rf-seller-list {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.rf-seller {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rf-swatch {
  width: 9px;
  height: 9px;
  border-radius: 2px;
  flex-shrink: 0;
  display: block;
}
.rf-seller-name {
  font-size: 12.5px;
  color: var(--rf-body);
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-seller-share {
  font-size: 11.5px;
  color: var(--rf-muted-2);
  font-variant-numeric: tabular-nums;
}
.rf-seller-value {
  font-size: 12.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  width: 52px;
  text-align: right;
}

/* areas */
.rf-areas-card {
  padding: 16px 20px;
}
.rf-areas-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
}
.rf-areas {
  display: flex;
  gap: 8px;
}
.rf-area {
  flex-grow: 1;
  background: var(--rf-gold-tint);
  border-radius: 9px;
  padding: 10px 12px;
}
.rf-area-value {
  font-size: 24px;
  line-height: 1;
  color: var(--rf-gold);
  font-variant-numeric: tabular-nums;
}
.rf-area-name {
  font-size: 11.5px;
  color: var(--rf-body-2);
  margin-top: 4px;
}

/* ---------------- responsive: tablet ---------------- */
/* exit to group overview — pinned to the sidebar bottom */
.rf-sidebar-exit {
  border-top: 1px solid var(--rf-line);
  padding: 10px 14px;
}
.rf-exit-btn {
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 10px;
  border: 1px solid var(--rf-line);
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--rf-body);
}
.rf-exit-btn:hover {
  background: var(--rf-gold-tint);
  border-color: var(--rf-gold-lite);
  color: var(--rf-ink);
}
.rf-exit-btn .rf-exit-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rf-exit-btn .rf-nav-icon {
  margin-left: auto;
}
.rf-app.is-collapsed .rf-sidebar-exit {
  padding: 10px 8px;
}
.rf-app.is-collapsed .rf-exit-btn {
  justify-content: center;
  padding: 0;
}
.rf-app.is-collapsed .rf-exit-btn .rf-exit-label {
  display: none;
}
.rf-app.is-collapsed .rf-exit-btn .rf-nav-icon {
  margin-left: 0;
  font-size: 19px;
}

/* ---------- sidebar collapse (icon rail) ---------- */
.rf-app.is-collapsed .rf-sidebar {
  width: 72px;
}
.rf-app.is-collapsed .rf-nav-label,
.rf-app.is-collapsed .rf-nav-dot,
.rf-app.is-collapsed .rf-user-text,
.rf-app.is-collapsed .rf-user-switch {
  display: none;
}
.rf-app.is-collapsed .rf-nav-item,
.rf-app.is-collapsed .rf-sidebar-user {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}
.rf-app.is-collapsed .rf-nav-item {
  position: relative;
}
.rf-app.is-collapsed .rf-nav-icon {
  font-size: 19px;
}
/* count rides the icon as a badge */
.rf-app.is-collapsed .rf-nav-count {
  position: absolute;
  top: 1px;
  right: 9px;
  padding: 0 4px;
  font-size: 9.5px;
  line-height: 14px;
  min-width: 14px;
  text-align: center;
}
/* group eyebrows become thin rules — in the same box the label had
   (padding and line box untouched, text hidden), so the rows below keep
   their exact vertical position across the collapse */
.rf-app.is-collapsed .rf-nav-eyebrow {
  overflow: hidden;
  white-space: nowrap;
  color: transparent;
  background: linear-gradient(var(--rf-line), var(--rf-line)) no-repeat;
  background-size: calc(100% - 28px) 1px;
  /* centred on the label's line, not the whole padded box */
  background-position: center calc(100% - 12px);
}

@media (max-width: 1200px) {
  .rf-dash-grid {
    grid-template-columns: 1fr;
  }
  .rf-kpis {
    grid-template-columns: repeat(2, 1fr);
  }
  /* sidebar collapse below 1200px is driven by AppShell (is-collapsed) */
  .rf-search {
    min-width: 0;
    width: 180px;
  }
}

/* ---------- page-level helpers (wired build) ---------- */
/* Loading glare — same treatment as the group overview (overview.css).
   While .rf-dash has .is-loading, every card keeps its size (and the data
   it last showed, hidden) under a tinted block with a sweeping glare. */
.rf-dash.is-loading .rf-kpi,
.rf-dash.is-loading .rf-card,
.rf-dash.is-loading .rf-revenue {
  position: relative;
  overflow: hidden;
  --skel-tint: #f1eee7;
  --skel-glare: rgba(255, 255, 255, 0.75);
}
.rf-dash.is-loading .rf-revenue {
  --skel-tint: #26221c;
  --skel-glare: rgba(255, 255, 255, 0.09);
}
.rf-dash.is-loading .rf-kpi > *,
.rf-dash.is-loading .rf-card > *,
.rf-dash.is-loading .rf-revenue > * {
  visibility: hidden;
}
.rf-dash.is-loading .rf-kpi::before,
.rf-dash.is-loading .rf-card::before,
.rf-dash.is-loading .rf-revenue::before,
.rf-dash.is-loading .rf-kpi::after,
.rf-dash.is-loading .rf-card::after,
.rf-dash.is-loading .rf-revenue::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.rf-dash.is-loading .rf-kpi::before,
.rf-dash.is-loading .rf-card::before,
.rf-dash.is-loading .rf-revenue::before {
  background: var(--skel-tint);
}
.rf-dash.is-loading .rf-kpi::after,
.rf-dash.is-loading .rf-card::after,
.rf-dash.is-loading .rf-revenue::after {
  background: linear-gradient(
    100deg,
    transparent 35%,
    var(--skel-glare) 50%,
    transparent 65%
  );
  background-size: 250% 100%;
  animation: rf-glare 1.5s ease-in-out infinite;
}
/* the first load has no data yet — give the cards their usual heights */
.rf-dash.is-loading .rf-kpi {
  min-height: 104px;
}
.rf-dash.is-loading .rf-card {
  min-height: 150px;
}
.rf-dash.is-loading .rf-revenue {
  min-height: 260px;
}
@keyframes rf-glare {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .rf-dash.is-loading .rf-kpi::after,
  .rf-dash.is-loading .rf-card::after,
  .rf-dash.is-loading .rf-revenue::after {
    animation: none;
  }
}
/* Range picker — mirrors the group overview's (.ov-datepicker). */
.rf-datepicker {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}
.rf-range-btn {
  height: 36px;
  font-family: inherit;
  color: inherit;
  border: 1px solid var(--rf-line);
  border-radius: 9px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 13px;
  cursor: pointer;
}
.rf-range-btn:hover,
.rf-range-btn.is-open {
  border-color: var(--rf-gold-lite);
}
.rf-range-label {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.rf-range-days {
  font-size: 11.5px;
  color: var(--rf-muted-2);
  white-space: nowrap;
}
.rf-range-caret {
  font-size: 10px;
  color: var(--rf-muted-2);
}
.rf-rangecal {
  position: absolute;
  left: 0;
  top: 44px;
  z-index: 40;
  width: 512px;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 12px;
  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.16);
  padding: 16px 18px;
}
.rf-rangecal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 13.5px;
  font-weight: 600;
}
.rf-rangecal-close {
  background: none;
  border: none;
  padding: 0;
  font-size: 16px;
  line-height: 1;
  color: var(--rf-muted-3);
  cursor: pointer;
}
.rf-rangecal-inputs {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.rf-rangecal-field {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.rf-rangecal-field label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-muted);
  white-space: nowrap;
}
.rf-rangecal-field input {
  height: 38px;
  border: 1px solid var(--rf-line);
  border-radius: 8px;
  background: var(--rf-card-soft);
  padding: 0 12px;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-ink);
  outline: none;
  font-variant-numeric: tabular-nums;
}
.rf-rangecal-months {
  display: flex;
  gap: 16px;
}
.rf-rangecal-foot {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--rf-line-soft);
}
.rf-rangecal-foot span {
  font-size: 11.5px;
  color: var(--rf-muted-2);
  flex-grow: 1;
}
.rf-rangecal-foot .rf-btn-primary:disabled {
  opacity: 0.5;
  cursor: default;
  background: var(--rf-gold);
}
@media (max-width: 700px) {
  .rf-rangecal {
    width: 380px;
  }
  .rf-rangecal-months {
    flex-wrap: wrap;
  }
}
.rf-empty {
  padding: 24px 0;
  font-size: 12.5px;
  color: var(--rf-muted-2);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/dashboard-redesign.css"],"names":[],"mappings":"AAAA;;6CAE6C;;AAE7C;;;EAGE,sBAAsB;EACtB,kEAAkE;EAClE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,sCAAsC;EACtC,oCAAoC;EACpC,wCAAwC;EACxC,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,aAAa;EACb,qEAAqE;EACrE,wBAAwB;EACxB,WAAW;EACX,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,4DAA4D;EAC5D,mCAAmC;AACrC;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd;kCACgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gEAAgE;EAChE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,8DAA8D;EAC9D,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;;AAEA,qDAAqD;AACrD;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;oEACoE;AACpE;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,4EAA4E;EAC5E,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8DAA8D;EAC9D,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,8DAA8D;EAC9D,aAAa;EACb,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,mDAAmD;EACnD,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,yDAAyD;AACzD,0DAA0D;AAC1D;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,WAAW;AACb;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;;sDAEsD;AACtD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qEAAqE;EACrE,sCAAsC;EACtC,0DAA0D;EAC1D,6CAA6C;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;EACA,uEAAuE;EACvE;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA,2DAA2D;AAC3D;;wEAEwE;AACxE;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,uCAAuC;AACzC;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE;;;;;GAKC;EACD,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA,wEAAwE;AACxE;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;;;IAGE,eAAe;EACjB;AACF;AACA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gEAAgE;EAChE,oBAAoB;EACpB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":["/* Dashboard redesign + app shell.\n   Scoped under .rf-app / .rf-dash so it can coexist with App.css and style.css\n   while the old dashboard is still routed. */\n\n.rf-app *,\n.rf-app *::before,\n.rf-app *::after {\n  box-sizing: border-box;\n  /* App.css sets `* { transition: 300ms }`; this design has none. */\n  transition: none;\n}\n.rf-app {\n  --rf-ink: #191714;\n  --rf-ink-hover: #332e26;\n  --rf-canvas: #f6f4ef;\n  --rf-card: #ffffff;\n  --rf-card-soft: #fdfcfa;\n  --rf-line: #e7e3da;\n  --rf-line-soft: #f0ece3;\n  --rf-muted: #8b8477;\n  --rf-muted-2: #a29b8d;\n  --rf-muted-3: #bdb6a7;\n  --rf-body: #4a453c;\n  --rf-body-2: #6f6a60;\n  --rf-gold: var(--rf-brand);\n  --rf-gold-hover: var(--rf-brand-hover);\n  --rf-gold-lite: var(--rf-brand-lite);\n  --rf-gold-bright: var(--rf-brand-bright);\n  --rf-gold-tint: var(--rf-brand-tint);\n  --rf-gold-tint-2: var(--rf-brand-line);\n  --rf-teal: var(--rf-accent);\n  --rf-up: #4d7a52;\n  --rf-up-bg: #eaf1e9;\n  --rf-warn: #b0872f;\n  --rf-warn-bg: #f9f1de;\n  --rf-down: #a8483e;\n  --rf-down-bg: #f7ebe9;\n  --rf-track: #eae6dd;\n  --rf-dark-line: #302b23;\n  --rf-dark-rule: #3a352c;\n  --rf-dark-body: #b8b1a3;\n\n  display: flex;\n  /* the whole app sits in a rounded card with a 5px gutter around it */\n  width: calc(100% - 10px);\n  margin: 5px;\n  min-height: calc(100vh - 10px);\n  border: 1px solid var(--rf-line);\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--rf-canvas);\n  color: var(--rf-ink);\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n.rf-app *,\n.rf-app *::before,\n.rf-app *::after {\n  box-sizing: border-box;\n}\n.rf-serif {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-weight: 400;\n}\n.rf-num {\n  font-variant-numeric: tabular-nums;\n}\n.rf-nowrap {\n  white-space: nowrap;\n}\n.rf-spacer {\n  flex-grow: 1;\n}\n.rf-app a {\n  color: var(--rf-gold);\n  text-decoration: none;\n}\n.rf-app a:hover {\n  color: var(--rf-gold-lite);\n}\n\n/* ---------------- sidebar ---------------- */\n.rf-sidebar {\n  position: relative;\n  width: 236px;\n  flex-shrink: 0;\n  /* the slide (AppShell) passes through widths neither layout was built\n     for — clip rather than wrap */\n  overflow: hidden;\n  background: var(--rf-card);\n  border-right: 1px solid var(--rf-line);\n  display: flex;\n  flex-direction: column;\n}\n.rf-nav {\n  padding: 14px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  flex-grow: 1;\n  overflow-y: auto;\n}\n.rf-nav-eyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--rf-muted-2);\n  padding: 8px 10px 6px;\n}\n.rf-nav-eyebrow.is-second {\n  padding-top: 18px;\n}\n.rf-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 36px;\n  padding: 0 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font: 500 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-body);\n  text-align: left;\n  width: 100%;\n}\n.rf-nav-item.is-secondary {\n  height: 34px;\n}\n.rf-nav-item:hover {\n  background: var(--rf-canvas);\n}\n.rf-nav-item.is-active {\n  background: #f2ede2;\n  color: var(--rf-ink);\n  font-weight: 600;\n}\n.rf-nav-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #d8d2c5;\n  flex-shrink: 0;\n}\n.rf-nav-item.is-active .rf-nav-dot {\n  background: var(--rf-gold-lite);\n}\n.rf-nav-label {\n  flex-grow: 1;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.rf-nav-icon {\n  font-size: 16px;\n  color: var(--rf-body);\n  flex-shrink: 0;\n}\n.rf-nav-item.is-active .rf-nav-icon {\n  color: var(--rf-gold);\n}\n.rf-nav-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--rf-brand-deep);\n  background: var(--rf-line-soft);\n  padding: 2px 7px;\n  border-radius: 20px;\n  font-variant-numeric: tabular-nums;\n}\n.rf-nav-item.is-active .rf-nav-count {\n  background: var(--rf-gold-tint-2);\n}\n.rf-sidebar-user {\n  border-top: 1px solid var(--rf-line);\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rf-sidebar-user img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.rf-user-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rf-user-name {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-user-role {\n  font-size: 11px;\n  color: var(--rf-muted);\n}\n.rf-user-switch {\n  font: 600 11px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-gold);\n  cursor: pointer;\n  padding: 4px 8px;\n  border: 1px solid var(--rf-line);\n  border-radius: 6px;\n  background: transparent;\n}\n.rf-user-switch:hover {\n  background: var(--rf-gold-tint);\n}\n\n/* ---------------- main + top bar ---------------- */\n.rf-main {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n/* bare chrome mode: wrappers vanish from layout, children keep their\n   legacy layout context (and no rf-app fonts/vars leak onto them) */\n.rf-bare {\n  display: contents;\n}\n.rf-content {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n.rf-topbar {\n  height: 64px;\n  flex-shrink: 0;\n  background: var(--rf-card);\n  border-bottom: 1px solid var(--rf-line);\n  display: flex;\n  align-items: center;\n  padding: 0 28px;\n  gap: 20px;\n  /* App.css styles bare <header> globally (margin/bold/centered) — reset it */\n  margin: 0;\n  font-weight: normal;\n  text-align: left;\n}\n.rf-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--rf-line);\n  border-radius: 8px;\n  background: var(--rf-card-soft);\n  min-width: 260px;\n  cursor: text;\n}\n.rf-search-icon {\n  width: 13px;\n  height: 13px;\n  border: 1.5px solid var(--rf-muted-2);\n  border-radius: 50%;\n  display: block;\n  flex-shrink: 0;\n}\n.rf-search input {\n  border: none;\n  background: none;\n  outline: none;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-ink);\n  width: 100%;\n}\n.rf-search input::placeholder {\n  color: var(--rf-muted-2);\n}\n.rf-clock {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  color: var(--rf-body);\n  border-left: 1px solid var(--rf-line);\n  height: 34px;\n  padding-left: 16px;\n}\n.rf-clock b {\n  font-weight: 600;\n  color: var(--rf-ink);\n}\n.rf-clock span {\n  color: var(--rf-muted-2);\n}\n\n/* ---------------- shared controls ---------------- */\n.rf-segmented {\n  display: flex;\n  gap: 2px;\n  background: var(--rf-track);\n  padding: 3px;\n  border-radius: 9px;\n}\n.rf-segmented button {\n  border: none;\n  cursor: pointer;\n  padding: 6px 13px;\n  border-radius: 7px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  background: transparent;\n  color: #7c766a;\n  white-space: nowrap;\n}\n.rf-segmented button.is-active {\n  background: #fff;\n  color: var(--rf-ink);\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);\n}\n.rf-btn {\n  cursor: pointer;\n  height: 34px;\n  border-radius: 8px;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  white-space: nowrap;\n}\n.rf-btn-ghost {\n  padding: 0 14px;\n  border: 1px solid var(--rf-line);\n  background: #fff;\n  color: var(--rf-body);\n}\n.rf-btn-ghost:hover {\n  background: var(--rf-canvas);\n}\n.rf-btn-primary {\n  padding: 0 16px;\n  border: none;\n  background: var(--rf-gold);\n  color: #fff;\n}\n.rf-btn-primary:hover {\n  background: var(--rf-gold-hover);\n}\n\n.rf-card {\n  background: var(--rf-card);\n  border: 1px solid var(--rf-line);\n  border-radius: 12px;\n  padding: 18px 20px;\n}\n.rf-card-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n.rf-card-title {\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.rf-card-meta {\n  font-size: 12px;\n  color: var(--rf-muted);\n  white-space: nowrap;\n  padding-left: 12px;\n}\n\n/* ---------------- dashboard ---------------- */\n.rf-dash {\n  flex-grow: 1;\n  padding: 22px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  min-height: 0;\n}\n.rf-dash-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.rf-dash-datemeta {\n  font-size: 13px;\n  color: var(--rf-body-2);\n  white-space: nowrap;\n}\n.rf-dash-datemeta b {\n  color: var(--rf-ink);\n  font-weight: 600;\n}\n\n.rf-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n}\n.rf-kpi {\n  background: var(--rf-card);\n  border: 1px solid var(--rf-line);\n  border-radius: 12px;\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rf-kpi-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.rf-kpi-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-muted);\n  white-space: nowrap;\n}\n.rf-kpi-chip {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n.rf-kpi-chip.tone-up {\n  color: var(--rf-up);\n  background: var(--rf-up-bg);\n}\n.rf-kpi-chip.tone-warn {\n  color: var(--rf-warn);\n  background: var(--rf-warn-bg);\n}\n.rf-kpi-chip.tone-down {\n  color: var(--rf-down);\n  background: var(--rf-down-bg);\n}\n.rf-kpi-value {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n.rf-kpi-value .rf-figure {\n  font-size: 40px;\n  line-height: 0.95;\n}\n.rf-kpi-unit {\n  font-size: 12.5px;\n  color: var(--rf-muted);\n  padding-bottom: 5px;\n}\n.rf-kpi-sub {\n  font-size: 12px;\n  color: var(--rf-body-2);\n}\n\n.rf-dash-grid {\n  display: grid;\n  grid-template-columns: 1.35fr 1fr;\n  gap: 16px;\n  flex-grow: 1;\n  min-height: 0;\n}\n.rf-dash-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n}\n\n/* pipeline */\n.rf-pipeline {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.rf-pipeline-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.rf-pipeline-label {\n  width: 132px;\n  flex-shrink: 0;\n}\n.rf-pipeline-task {\n  font-size: 13px;\n  font-weight: 600;\n}\n.rf-pipeline-sub {\n  font-size: 11.5px;\n  color: var(--rf-muted);\n}\n.rf-track {\n  flex-grow: 1;\n  height: 10px;\n  background: var(--rf-line-soft);\n  border-radius: 20px;\n  overflow: hidden;\n}\n.rf-track > span {\n  display: block;\n  height: 100%;\n  border-radius: 20px;\n}\n.rf-pipeline-count {\n  width: 76px;\n  text-align: right;\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n}\n.rf-pipeline-count b {\n  font-weight: 600;\n}\n.rf-pipeline-count span {\n  color: var(--rf-muted-2);\n}\n.rf-pipeline-pct {\n  width: 42px;\n  text-align: right;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n/* chart */\n.rf-chart-card {\n  display: flex;\n  flex-direction: column;\n}\n.rf-chart-head {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  margin-bottom: 4px;\n}\n.rf-legend-group {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.rf-legend {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--rf-body-2);\n  white-space: nowrap;\n}\n.rf-legend i {\n  width: 14px;\n  height: 2px;\n  display: block;\n}\n.rf-chart-lede {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.rf-chart-lede .rf-figure {\n  font-size: 30px;\n  line-height: 1;\n}\n.rf-chart-lede span {\n  font-size: 12.5px;\n  color: var(--rf-muted);\n}\n.rf-chart {\n  /* fixed height: the design's 210 chart units reduced by 30% */\n  height: 147px;\n  position: relative;\n}\n\n/* recent activity */\n.rf-activity {\n  display: flex;\n  flex-direction: column;\n}\n.rf-activity-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 0;\n  border-top: 1px solid var(--rf-line-soft);\n}\n.rf-activity-row:first-child {\n  border-top: none;\n  padding-top: 0;\n}\n.rf-activity-row:last-child {\n  padding-bottom: 0;\n}\n.rf-activity-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.rf-activity-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rf-activity-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--rf-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-activity-detail {\n  font-size: 11.5px;\n  color: var(--rf-muted);\n  margin-top: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-activity-amount {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--rf-ink);\n  white-space: nowrap;\n}\n.rf-activity-time {\n  font-size: 11.5px;\n  color: var(--rf-muted-2);\n  white-space: nowrap;\n  min-width: 38px;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n/* revenue (owner only) */\n.rf-revenue {\n  background: var(--rf-ink);\n  border-radius: 12px;\n  padding: 18px 20px;\n  color: #fff;\n}\n.rf-revenue .rf-card-title {\n  color: #fff;\n}\n.rf-revenue-owner {\n  font-size: 11.5px;\n  color: var(--rf-muted-2);\n}\n.rf-revenue-figures {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 16px;\n}\n.rf-revenue-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-muted-2);\n  margin-bottom: 4px;\n}\n.rf-revenue-figure {\n  font-size: 34px;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n.rf-revenue-figure.is-gross {\n  color: var(--rf-gold-bright);\n}\n.rf-revenue-figure.is-net {\n  color: #fff;\n}\n.rf-revenue-rule {\n  width: 1px;\n  background: var(--rf-dark-rule);\n}\n.rf-revenue-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 0;\n  border-top: 1px solid var(--rf-dark-line);\n  font-size: 12.5px;\n}\n.rf-revenue-row dt {\n  margin: 0;\n  color: var(--rf-dark-body);\n}\n.rf-revenue-row dd {\n  margin: 0;\n  color: #fff;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n/* top sellers */\n.rf-sellers-card {\n  /* hug the donut — no stretch, ~10px of air below */\n  flex-grow: 0;\n  padding-bottom: 10px;\n}\n.rf-sellers {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n.rf-donut {\n  width: 200px;\n  height: 200px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rf-donut-hole {\n  width: 127px;\n  height: 127px;\n  border-radius: 50%;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.rf-donut-total {\n  font-size: 26px;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n.rf-donut-caption {\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--rf-muted-2);\n  margin-top: 3px;\n}\n.rf-seller-list {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.rf-seller {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.rf-swatch {\n  width: 9px;\n  height: 9px;\n  border-radius: 2px;\n  flex-shrink: 0;\n  display: block;\n}\n.rf-seller-name {\n  font-size: 12.5px;\n  color: var(--rf-body);\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-seller-share {\n  font-size: 11.5px;\n  color: var(--rf-muted-2);\n  font-variant-numeric: tabular-nums;\n}\n.rf-seller-value {\n  font-size: 12.5px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  width: 52px;\n  text-align: right;\n}\n\n/* areas */\n.rf-areas-card {\n  padding: 16px 20px;\n}\n.rf-areas-title {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n.rf-areas {\n  display: flex;\n  gap: 8px;\n}\n.rf-area {\n  flex-grow: 1;\n  background: var(--rf-gold-tint);\n  border-radius: 9px;\n  padding: 10px 12px;\n}\n.rf-area-value {\n  font-size: 24px;\n  line-height: 1;\n  color: var(--rf-gold);\n  font-variant-numeric: tabular-nums;\n}\n.rf-area-name {\n  font-size: 11.5px;\n  color: var(--rf-body-2);\n  margin-top: 4px;\n}\n\n/* ---------------- responsive: tablet ---------------- */\n/* exit to group overview — pinned to the sidebar bottom */\n.rf-sidebar-exit {\n  border-top: 1px solid var(--rf-line);\n  padding: 10px 14px;\n}\n.rf-exit-btn {\n  width: 100%;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 10px;\n  border: 1px solid var(--rf-line);\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--rf-body);\n}\n.rf-exit-btn:hover {\n  background: var(--rf-gold-tint);\n  border-color: var(--rf-gold-lite);\n  color: var(--rf-ink);\n}\n.rf-exit-btn .rf-exit-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rf-exit-btn .rf-nav-icon {\n  margin-left: auto;\n}\n.rf-app.is-collapsed .rf-sidebar-exit {\n  padding: 10px 8px;\n}\n.rf-app.is-collapsed .rf-exit-btn {\n  justify-content: center;\n  padding: 0;\n}\n.rf-app.is-collapsed .rf-exit-btn .rf-exit-label {\n  display: none;\n}\n.rf-app.is-collapsed .rf-exit-btn .rf-nav-icon {\n  margin-left: 0;\n  font-size: 19px;\n}\n\n/* ---------- sidebar collapse (icon rail) ---------- */\n.rf-app.is-collapsed .rf-sidebar {\n  width: 72px;\n}\n.rf-app.is-collapsed .rf-nav-label,\n.rf-app.is-collapsed .rf-nav-dot,\n.rf-app.is-collapsed .rf-user-text,\n.rf-app.is-collapsed .rf-user-switch {\n  display: none;\n}\n.rf-app.is-collapsed .rf-nav-item,\n.rf-app.is-collapsed .rf-sidebar-user {\n  justify-content: center;\n  padding-left: 0;\n  padding-right: 0;\n}\n.rf-app.is-collapsed .rf-nav-item {\n  position: relative;\n}\n.rf-app.is-collapsed .rf-nav-icon {\n  font-size: 19px;\n}\n/* count rides the icon as a badge */\n.rf-app.is-collapsed .rf-nav-count {\n  position: absolute;\n  top: 1px;\n  right: 9px;\n  padding: 0 4px;\n  font-size: 9.5px;\n  line-height: 14px;\n  min-width: 14px;\n  text-align: center;\n}\n/* group eyebrows become thin rules — in the same box the label had\n   (padding and line box untouched, text hidden), so the rows below keep\n   their exact vertical position across the collapse */\n.rf-app.is-collapsed .rf-nav-eyebrow {\n  overflow: hidden;\n  white-space: nowrap;\n  color: transparent;\n  background: linear-gradient(var(--rf-line), var(--rf-line)) no-repeat;\n  background-size: calc(100% - 28px) 1px;\n  /* centred on the label's line, not the whole padded box */\n  background-position: center calc(100% - 12px);\n}\n\n@media (max-width: 1200px) {\n  .rf-dash-grid {\n    grid-template-columns: 1fr;\n  }\n  .rf-kpis {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  /* sidebar collapse below 1200px is driven by AppShell (is-collapsed) */\n  .rf-search {\n    min-width: 0;\n    width: 180px;\n  }\n}\n\n/* ---------- page-level helpers (wired build) ---------- */\n/* Loading glare — same treatment as the group overview (overview.css).\n   While .rf-dash has .is-loading, every card keeps its size (and the data\n   it last showed, hidden) under a tinted block with a sweeping glare. */\n.rf-dash.is-loading .rf-kpi,\n.rf-dash.is-loading .rf-card,\n.rf-dash.is-loading .rf-revenue {\n  position: relative;\n  overflow: hidden;\n  --skel-tint: #f1eee7;\n  --skel-glare: rgba(255, 255, 255, 0.75);\n}\n.rf-dash.is-loading .rf-revenue {\n  --skel-tint: #26221c;\n  --skel-glare: rgba(255, 255, 255, 0.09);\n}\n.rf-dash.is-loading .rf-kpi > *,\n.rf-dash.is-loading .rf-card > *,\n.rf-dash.is-loading .rf-revenue > * {\n  visibility: hidden;\n}\n.rf-dash.is-loading .rf-kpi::before,\n.rf-dash.is-loading .rf-card::before,\n.rf-dash.is-loading .rf-revenue::before,\n.rf-dash.is-loading .rf-kpi::after,\n.rf-dash.is-loading .rf-card::after,\n.rf-dash.is-loading .rf-revenue::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n.rf-dash.is-loading .rf-kpi::before,\n.rf-dash.is-loading .rf-card::before,\n.rf-dash.is-loading .rf-revenue::before {\n  background: var(--skel-tint);\n}\n.rf-dash.is-loading .rf-kpi::after,\n.rf-dash.is-loading .rf-card::after,\n.rf-dash.is-loading .rf-revenue::after {\n  background: linear-gradient(\n    100deg,\n    transparent 35%,\n    var(--skel-glare) 50%,\n    transparent 65%\n  );\n  background-size: 250% 100%;\n  animation: rf-glare 1.5s ease-in-out infinite;\n}\n/* the first load has no data yet — give the cards their usual heights */\n.rf-dash.is-loading .rf-kpi {\n  min-height: 104px;\n}\n.rf-dash.is-loading .rf-card {\n  min-height: 150px;\n}\n.rf-dash.is-loading .rf-revenue {\n  min-height: 260px;\n}\n@keyframes rf-glare {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -100% 0;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .rf-dash.is-loading .rf-kpi::after,\n  .rf-dash.is-loading .rf-card::after,\n  .rf-dash.is-loading .rf-revenue::after {\n    animation: none;\n  }\n}\n/* Range picker — mirrors the group overview's (.ov-datepicker). */\n.rf-datepicker {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n.rf-range-btn {\n  height: 36px;\n  font-family: inherit;\n  color: inherit;\n  border: 1px solid var(--rf-line);\n  border-radius: 9px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 13px;\n  cursor: pointer;\n}\n.rf-range-btn:hover,\n.rf-range-btn.is-open {\n  border-color: var(--rf-gold-lite);\n}\n.rf-range-label {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.rf-range-days {\n  font-size: 11.5px;\n  color: var(--rf-muted-2);\n  white-space: nowrap;\n}\n.rf-range-caret {\n  font-size: 10px;\n  color: var(--rf-muted-2);\n}\n.rf-rangecal {\n  position: absolute;\n  left: 0;\n  top: 44px;\n  z-index: 40;\n  width: 512px;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 12px;\n  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.16);\n  padding: 16px 18px;\n}\n.rf-rangecal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  font-size: 13.5px;\n  font-weight: 600;\n}\n.rf-rangecal-close {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1;\n  color: var(--rf-muted-3);\n  cursor: pointer;\n}\n.rf-rangecal-inputs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.rf-rangecal-field {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.rf-rangecal-field label {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-muted);\n  white-space: nowrap;\n}\n.rf-rangecal-field input {\n  height: 38px;\n  border: 1px solid var(--rf-line);\n  border-radius: 8px;\n  background: var(--rf-card-soft);\n  padding: 0 12px;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-ink);\n  outline: none;\n  font-variant-numeric: tabular-nums;\n}\n.rf-rangecal-months {\n  display: flex;\n  gap: 16px;\n}\n.rf-rangecal-foot {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--rf-line-soft);\n}\n.rf-rangecal-foot span {\n  font-size: 11.5px;\n  color: var(--rf-muted-2);\n  flex-grow: 1;\n}\n.rf-rangecal-foot .rf-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: default;\n  background: var(--rf-gold);\n}\n@media (max-width: 700px) {\n  .rf-rangecal {\n    width: 380px;\n  }\n  .rf-rangecal-months {\n    flex-wrap: wrap;\n  }\n}\n.rf-empty {\n  padding: 24px 0;\n  font-size: 12.5px;\n  color: var(--rf-muted-2);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
